var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "group-page-chat" }, [
    _c(
      "div",
      { staticClass: "group-page-chat__info-panel" },
      [
        _c("chats-list-new-messages-counter", {
          attrs: {
            "total-messages-count": _vm.chat.messages_count,
            "unread-messages-count": _vm.chat.unread_count,
          },
        }),
        _vm._v(" "),
        _vm.chat.following
          ? _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Leave Chat",
                  expression: "'Leave Chat'",
                },
              ],
              staticClass:
                "fal fa-minus-square color-footer-red group-page-chat__counter-icon group-page-chat__counter-icon_delete pointer",
              on: {
                click: _vm.leave,
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.leave.apply(null, arguments)
                },
              },
            })
          : _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Follow Chat",
                  expression: "'Follow Chat'",
                },
              ],
              staticClass:
                "fal fa-plus-square color-grass-green-dark group-page-chat__counter-icon group-page-chat__counter-icon_delete pointer",
              on: {
                click: _vm.follow,
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.follow.apply(null, arguments)
                },
              },
            }),
        _vm._v(" "),
        _c("span", { staticClass: "group-page-chat__time-label" }, [
          _vm._v(_vm._s(_vm.lastMessageTime)),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "group-page-chat__chat-name" }, [
      _vm.chat.link
        ? _c("a", { attrs: { href: _vm._f("backHrefQuery")(_vm.chat.link) } }, [
            _vm._v(_vm._s(_vm._f("cutName")(_vm.chat.name, 100)) + " "),
            !_vm.chat.approved
              ? _c("span", { staticClass: "color-tag-gray" }, [
                  _vm._v("(Not Approved)"),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "group-page-chat__chat-info" }, [
      _c("div", { staticClass: "margin-15-top" }, [
        _c("span", [_vm._v("Created by:")]),
        _vm._v(" "),
        _c(
          "strong",
          [_c("simple-link", { attrs: { target: _vm.chat.created_by } })],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", [_vm._v("Created at:")]),
        _vm._v(" "),
        _c("strong", [_vm._v(_vm._s(_vm._f("gbdate")(_vm.chat.created_at)))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }